import styled from 'styled-components';

interface Props {
  height: number;
}

export default styled.div`
  height: ${(props: Props) => `${props.height}px`};
  transition: height 0.2s ease-in-out;
  overflow: hidden;
  will-change: height;
`;
